import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Truck, Calendar, ArrowLeft, LogOut } from 'lucide-react';
import { Button } from './ui/button';

const AdminHeader = ({ title, subtitle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_token_time');
    navigate('/login', { replace: true });
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-[#1a1a1a] border-b border-[#2C3E50] py-2 md:py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4">
          <Link to="/" className="flex items-center gap-2 text-white hover:text-[#FDB913] transition-colors">
            <Truck className="h-6 w-6 md:h-8 md:w-8" />
            <div>
              <h1 className="text-lg md:text-xl font-bold">Hogir Acar</h1>
              <p className="text-xs text-gray-300">{subtitle || title}</p>
            </div>
          </Link>
          <div className="flex flex-wrap gap-2 md:gap-4 justify-center w-full md:w-auto">
            {location.pathname !== '/admin' && (
              <Link to="/admin" className="flex-1 md:flex-initial">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className={`w-full ${isActive('/admin') ? 'bg-[#FDB913] text-[#1a1a1a]' : 'border-[#FDB913] text-[#FDB913] hover:bg-[#FDB913] hover:text-[#1a1a1a]'}`}
                >
                  <ArrowLeft className="mr-1 md:mr-2 h-4 w-4" />
                  Anfragen
                </Button>
              </Link>
            )}
            {location.pathname !== '/admin/vehicles' && (
              <Link to="/admin/vehicles" className="flex-1 md:flex-initial">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className={`w-full ${isActive('/admin/vehicles') ? 'bg-[#FDB913] text-[#1a1a1a]' : 'border-[#FDB913] text-[#FDB913] hover:bg-[#FDB913] hover:text-[#1a1a1a]'}`}
                >
                  <Truck className="mr-1 md:mr-2 h-4 w-4" />
                  <span className="hidden sm:inline">Fahrzeugübersicht</span>
                  <span className="sm:hidden">Fahrzeuge</span>
                </Button>
              </Link>
            )}
            {location.pathname !== '/admin/bookings' && (
              <Link to="/admin/bookings" className="flex-1 md:flex-initial">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className={`w-full ${isActive('/admin/bookings') ? 'bg-blue-500 text-white' : 'border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white'}`}
                >
                  <Calendar className="mr-1 md:mr-2 h-4 w-4" />
                  <span className="hidden sm:inline">Buchungskalender</span>
                  <span className="sm:hidden">Kalender</span>
                </Button>
              </Link>
            )}
            <Button 
              onClick={handleLogout} 
              variant="outline" 
              size="sm" 
              className="border-red-500 text-red-500 hover:bg-red-500 hover:text-white flex-1 md:flex-initial"
            >
              <LogOut className="mr-1 md:mr-2 h-4 w-4" />
              Abmelden
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
